import Page from '@/components/page'
function Decorate () {
  let decorateList = {
    console () {
      let g = window
      let logMaps = ['log', 'warn', 'error']
      g.console = g.console || {}
      logMaps.forEach(item => {
        if (!g.console[item]) g.console[item] = () => {}
      })
    }
  }
  return {
    add (namespace, fn) {
      if (decorateList[namespace]) {
        console.wran(`${namespace} 已存在`)
        return
      }
      decorateList[namespace] = fn
    },
    exec () {
      for (let i in decorateList) {
        decorateList[i] && decorateList[i].apply(this, arguments)
      }
    }
  }
}
let decorate = Decorate()
//兼容IE9下tabs animate默认值
decorate.add('iview-tabs', (Vue) => {
  let UA = window.navigator.userAgent.toLowerCase()
  let isIE9 = UA && UA.indexOf('msie 9.0') > 0
  if (isIE9) Vue.options.components.Tabs.options.props.animated.default = false
})
//自定义翻页组件
decorate.add('iview-page', (Vue) => {
  Vue.options.components.Page = Page
})
export default {
  install: function (Vue, options) {
    decorate.exec.apply(this, arguments)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/decorate/index.js